var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9391 35.5586C40.8306 35.2843 40.667 35.0352 40.4583 34.8268L33.7557 28.1242C32.8787 27.2771 31.4846 27.2892 30.6224 28.1514C29.7602 29.0136 29.7481 30.4077 30.5952 31.2847L33.485 34.1748H11.725L40.2779 11.334C41.0199 10.7411 41.3061 9.74407 40.9916 8.84788C40.6772 7.95169 39.8307 7.35209 38.8809 7.35277H8.51418L11.404 4.4627C11.9851 3.90151 12.2181 3.07047 12.0136 2.28899C11.809 1.50751 11.1987 0.897205 10.4172 0.692653C9.63574 0.488101 8.8047 0.72113 8.2435 1.30218L1.54091 8.00477C0.682977 8.88587 0.682977 10.29 1.54091 11.1711L8.2435 17.8737C9.12244 18.7314 10.5251 18.7314 11.404 17.8737C11.8234 17.4547 12.059 16.8862 12.059 16.2934C12.059 15.7006 11.8234 15.1322 11.404 14.7132L8.51418 11.8231H32.5094L3.95646 34.6638C3.2145 35.2567 2.92827 36.2538 3.24273 37.15C3.55719 38.0462 4.40367 38.6458 5.35343 38.6451H33.485L30.5952 41.5352C30.1758 41.9541 29.9402 42.5226 29.9402 43.1154C29.9402 43.7082 30.1758 44.2767 30.5952 44.6957C31.4734 45.555 32.8774 45.555 33.7557 44.6957L40.4583 37.9931C41.0848 37.3475 41.2732 36.3938 40.9391 35.5586Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.897461,
    y1: 0.619751,
    x2: 0.897461,
    y2: 45.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21C1E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.adec07aa08c47538c6015dd7c8b7ae6c.svg";
export { ForwardRef as ReactComponent };